import axiosClient from "config/axios";

const searchPatientProspect = async (dni) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await axiosClient.get(`/prospect-registration/prospects/search?dni=${dni}`, {headers});
        return response;
    } catch (error) {
        const { response } = error;
        return response;
    }
}

const registerProspect = async (prospect) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await axiosClient.post('/prospect-registration/prospects', prospect, {headers});
        return response;
    } catch (error) {
        const { response } = error;
        return response;
    }
}

const sendConsentData = async (prospect) => {
    const data = {
        phone: prospect.phone,
        email: prospect.email,
    }
    const idProspect = prospect.id || prospect._id;
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await axiosClient.post(`/prospect-registration/prospects/${idProspect}/accept-terms`, data, {headers});
        return response;
    } catch (error) {
        const { response } = error;
        return response;
    }
}

const sendConsentCode = async (prospect, code) => {
    const idProspect = prospect.id || prospect._id;
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await axiosClient.post(`/prospect-registration/prospects/${idProspect}/confirm-terms`, {code}, {headers});
        return response;
    } catch (error) {
        const response = error;
        return response;
    }
}

const getConsentPreview = async (prospect) => {
    const idProspect = prospect.id || prospect._id;
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const responseType = 'blob';
        const response = await axiosClient.get(`/prospect-registration/prospects/${idProspect}/preview-pdf`, {responseType, headers});
        return response;
    } catch (error) {
        const response = error;
        return response;
    }
}

export { searchPatientProspect, registerProspect, sendConsentData , sendConsentCode, getConsentPreview};